import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-icon-building-materials',
    templateUrl: './icon-building-materials.component.html',
    styleUrls: ['./icon-building-materials.component.scss']
})
export class IconBuildingMaterialsComponent implements OnInit {

    @Input() cssClass = 'icon--18';

    constructor() { }

    ngOnInit() {
    }

}
